import { render, staticRenderFns } from "./member_upgrade.vue?vue&type=template&id=159974fa&scoped=true"
import script from "./member_upgrade.vue?vue&type=script&lang=js"
export * from "./member_upgrade.vue?vue&type=script&lang=js"
import style0 from "./member_upgrade.vue?vue&type=style&index=0&id=159974fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159974fa",
  null
  
)

export default component.exports